import * as actionTypes from "./../actions/actionTypes";
import { IInvestmentSearchParams } from "../../interfaces/investment";

const initialState: IInvestmentSearchParams = {
  currency: "",
  searchValue: "",
  aggregatorId: "",
  dateSearchMode: 0,
  investmentStatus: 0,
  legalEntity: "",
};

const reducer = (
  state = initialState,
  action: { type: string; payload: IInvestmentSearchParams }
) => {
  switch (action.type) {
    case actionTypes.SET_ADVANCED_INVESTMENT_SEARCH_PARAMS:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
